/*** IMPORTS FROM imports-loader ***/
var define = false;

import { getAppBreakpoints } from './getAppBreakpoints'

const breakpoints = getAppBreakpoints()

window.APP.mq = {
  small: window.matchMedia(`screen and (max-width: calc(${breakpoints.medium} - 1px))`),
  medium: window.matchMedia(`screen and (min-width: ${breakpoints.medium})`),
  large: window.matchMedia(`screen and (min-width: ${breakpoints.large})`),
  xlarge: window.matchMedia(`screen and (min-width: ${breakpoints.xlarge})`),
  xxlarge: window.matchMedia(`screen and (min-width: ${breakpoints.xxlarge})`),
  xxxlarge: window.matchMedia(`screen and (min-width: ${breakpoints.xxlarge})`),
}

